<template>
  <div :class={mbtop:isTop()}>
    <header-member v-if="!isWebView()"></header-member>
    <router-view class="header-fixed"></router-view>
    <div class="container _textright">
      <btn-pagetop></btn-pagetop>
    </div>
    <footer-member></footer-member>
  </div>
</template>

<script>
import { isWebView } from '../../utils/UserAgent'
import BtnPagetop from '../button/BtnPagetop'
import HeaderMember from '../globals/HeaderMember'
import FooterMember from '../globals/FooterMember'
import { setSctvTag } from '../../utils/ExternalScripts'

export default {
  name: 'member-layout',
  components: {
    HeaderMember,
    BtnPagetop,
    FooterMember
  },
  methods: {
    isTop: function () {
      return this.$route.name === 'mb001'
    },
    isWebView: function () {
      return isWebView()
    }
  },
  mounted: function () {
    if (!window.__PRERENDER_INJECTED || !window.__PRERENDER_INJECTED.isPrerendering) {
      this.$gtm.enable(true)
      setSctvTag(this.$route.name)
    }
  },
  updated: function () {
    if (!window.__PRERENDER_INJECTED || !window.__PRERENDER_INJECTED.isPrerendering) {
      setSctvTag(this.$route.name)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .mbtop {
    @include mq-down(md) {
      padding-bottom: 50px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layouts/MemberLayout.vue